import axios from 'axios';

const client = axios.create({
  baseURL: '',
  //baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '',
  timeout: 20000,
  headers: {
    'Content-type': 'application/json; charset=UTF-8',
    Accept: 'application/json'
  },
  withCredentials: false
});

if (process.env.NODE_ENV === 'production') {
  console.log('debug production base url', process.env.VUE_APP_API_BASE_URL);
} else {
  console.log('we are not in production');
}

export default (() => {
  return {
    // new endpoints

    login: async data => await client.post('/api/login', data),

    refreshToken: async () => await client.post('/api/refresh-token'),

    orderLogin: async data => await client.post('/api/orderLogin', data),

    verifyEmailToken: async (token, params = {}) =>
      client.get('/api/authOrder/' + token, { params }),

    // pay: async data => await client.post('/api/pay', data),
    chooseOffer: async data => await client.post('/api/chooseOffer', data),

    signQuotation: async data => await client.post('/api/signQuotation', data),

    getBrokerOrders: async queryParams => client.get('/api/orders', { params: queryParams }),

    getBrokerOrdersCounters: async queryParams =>
      client.get('/api/orders/count', { params: queryParams }),

    getBrokerOrder: async id => client.get('/api/orders/' + id),

    deleteBrokerOrder: async id => client.delete('/api/orders/' + id),

    deleteAttachment: async id => client.delete('/api/attachments/' + id),

    addOrderItem: async (itemId, data) => {
      let payload = { item_id: itemId };
      if (data) payload = { ...payload, ...data };

      return client.post('/api/addOrderItem', payload);
    },

    addCustomer: async data => await client.post('/api/addCustomer', data),

    saveCustomer: async data => await client.put('/api/saveCustomer', data),

    updateOrderItem: async (itemId, data) =>
      await client.put(`/api/updateOrderItem/${itemId}`, data),

    saveSurveyOrderItems: async itemsSurveys => await client.put(`/api/saveSurvey`, itemsSurveys),

    removeOrderItem: async itemId => await client.delete(`/api/removeOrderItem/${itemId}`),

    getOrder: async refCode => client.get('/api/getOrder', { params: { ref: refCode } }),

    hasOrder: async () => client.get('/api/hasOrder'),

    editOrder: async (id, data) => client.put('/api/orders/' + id, data),

    getAuthOrder: async () => client.get('/api/getAuthOrder'),

    resetOrder: async () => await client.post('/api/resetOrder'),

    sendNoOfferContactRequest: async () => client.post('api/sendNoOfferContactRequest'),

    searchItems: async query => {
      let queryParams = {};
      if (query) queryParams.search = query;

      return client.get(`/api/searchItems`, { params: queryParams });
    },

    validateFiscalCode: async code =>
      client.get('/api/validateFiscaleCode', { params: { fiscal_code: code } }),

    validateCap: async code => client.get('/api/validateCap', { params: { postal_code: code } }),

    getSupportReasonList: async queryParams =>
      client.get('/api/getSupportReasonList', { params: queryParams }),

    sendSupportRequest: async data => client.post('/api/sendSupportRequest', data),

    verifySignatureStatus: async queryParams =>
      await client.get('/api/verifySignatureStatus', { params: queryParams }),
    // end new endpoints

    getResellers: async query => client.get('/api/resellers', { params: query }),

    addReseller: async payload => await client.post('/api/resellers', payload),
    deleteReseller: async id => await client.delete('/api/resellers/' + id),

    updateOrder: async (orderId, data) => {
      return client.put(`/api/orders/${orderId}`, data);
    },

    addOffersFeedback: async data => {
      return client.post(`/api/addOffersFeedback`, data);
    },

    createScalapayOrder: async orderCode =>
      await client.post('/api/payment/scalapay', { code: orderCode }),

    payScalapayOrder: async orderToken =>
      await client.post('/api/payment/scalapay/pay', { orderToken })
  };
})();
